import { useState } from 'react';
import PropTypes from 'prop-types';
// material
import {
  Card,
  CardHeader,
  CardContent,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody
} from '@material-ui/core';
import { Tooltip, IconButton } from '@mui/material';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VmDetailModal from './VmDetailModal';

VMInfo.propTypes = {
  rackDetails: PropTypes.object
};

export default function VMInfo({ rackDetails }) {
  const [open, setOpen] = useState(false);
  const [selectedVm, setSelectedVm] = useState(null);

  return (
    <Card data-testid="vm-info" sx={{ height: '100%' }}>
      <CardHeader title="VMs" />
      <CardContent>
        <TableContainer component={Paper}>
          <Table aria-label="simple table" size="small">
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell align="right">Arch</TableCell>
                <TableCell align="right">Persist Data</TableCell>
                <TableCell align="right">Disks</TableCell>
                <TableCell align="right">Networks</TableCell>
                <TableCell align="right">Details</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rackDetails.generic_vms.map((row, i) => (
                <TableRow key={i} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                  <TableCell component="th" scope="row">
                    {row.name}
                  </TableCell>
                  <TableCell align="right">{row.architecture ? row.architecture : '-'}</TableCell>
                  <TableCell align="right">
                    {row.persistData ? row.persistData.toString() : 'false'}
                  </TableCell>
                  <TableCell align="right">{row.disks?.length ?? 0}</TableCell>
                  <TableCell align="right">{row.network?.ports?.length ?? 0}</TableCell>
                  <TableCell align="right">
                    <Tooltip title="View VM details">
                      <IconButton
                        size="small"
                        onClick={() => {
                          setSelectedVm(row);
                          setOpen(true);
                        }}
                      >
                        <VisibilityOutlinedIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
      <VmDetailModal open={open} onClose={() => setOpen(false)} data={selectedVm} />
    </Card>
  );
}
